export default () => ({
  uploads: {
  },
  uploadByResourceId: {
    // resourceId: [upload, upload]
  },
  // specific variable, because of the proxy bug. only completed when the upload is confirmed
  uploadInProgress: false,
});
